// eslint-disable-next-line import/prefer-default-export
export const BASIC_DETAILS = 'Perustiedot';

export const WORKFLOW_OFFER = 'Workflow_tarjous';
